// INVOICE

export interface IAddInvoiceRequest {
    MemberID: number;
    CreditCardID: number;
    TryCapturePayment: boolean;
    DateTimeCreated: Date;
    DueDate: Date;
    LicenseID: number;
    ForceGrace: boolean;

    Items: AddInvoiceRequestItemArray;
}

export class AddInvoiceRequest implements IAddInvoiceRequest {
    MemberID: number;
    CreditCardID: number;
    TryCapturePayment: boolean;
    DateTimeCreated: Date;
    DueDate: Date;
    LicenseID: number;
    ForceGrace: boolean;
    IgnoreDiscountItems: boolean = true;

    Items: AddInvoiceRequestItemArray;
}



// ITEMS

export interface IAddInvoiceRequestItem {
    ID: number;
    Description: string;
    Amount: number;
}

export class AddInvoiceRequestItem implements IAddInvoiceRequestItem {
    ID: number;
    Description: string;
    Amount: number;
}

export class AddInvoiceRequestItemArray extends Array<IAddInvoiceRequestItem> {

    constructor(...items: AddInvoiceRequestItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AddInvoiceRequestItemArray.prototype);
    }
}
